import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import PageHeader from "../components/pageHeader"

// Styles for generated HTML project pages
import "../styles/project.css"

export default function ProjectTemplate({ data }) {
  const { markdownRemark } = data 
  const { frontmatter, html } = markdownRemark

  return (
    <Layout>
      <PageHeader>{frontmatter.title}</PageHeader>
      <div dangerouslySetInnerHTML={{ __html: html }}/>
    </Layout>
  )
}

export const pageQuery = graphql`
  query GetProject($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        slug
        title
      }
    }
  }
`
